import { useState } from 'react';
import {
  Dialog,
  Typography,
  Grid,
  Button,
  Stack,
  IconButton,
} from '@mui/material';

import TextField from '../text-field/TextField';
import Select from '../select/Select';
import Icon from '../Icon';

import {
  useGetProfilesQuery,
  useGetAuthenticationQuery,
  useGetAuthTokenQuery,
  useUpdateAgentMutation,
} from '../../services/ADapi';

const UpdateAgentModal = ({ uid, comment, onClose }) => {
  const {
    data: { user_id },
  } = useGetAuthenticationQuery();
  const { data: profiles = [] } = useGetProfilesQuery(user_id);

  const [agentData, setAgentData] = useState({
    profile: profiles[0].id,
    comment,
  });

  const {
    data: { access },
  } = useGetAuthTokenQuery();

  const [editAgent, { isLoading }] = useUpdateAgentMutation();

  const commentHandler = (e) => {
    setAgentData((prevState) => ({ ...prevState, comment: e.target.value }));
  };

  const policyHandler = (e) => {
    setAgentData((prevState) => ({ ...prevState, profile: e.target.value }));
  };

  const editAgentHandler = async (e) => {
    e.preventDefault();

    try {
      await editAgent({
        user_id,
        uid,
        agentData: {
          comment: agentData.comment,
          profile: agentData.profile,
        },
        token: access,
      }).unwrap();
      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Dialog open={true} className="MuiDialog-container" onClose={onClose}>
      <Stack sx={{ gap: 3 }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h3" component="h3">
            Edit agent
          </Typography>
          <IconButton onClick={onClose} sx={{ p: 0 }}>
            <Icon id="dismiss" />
          </IconButton>
        </Grid>
        <Stack component="form" sx={{ gap: 3 }}>
          <TextField
            id="comment"
            label="Comment"
            value={agentData.comment}
            size="small"
            onChange={commentHandler}
          />
          <Select
            label="Profile"
            onChange={policyHandler}
            value={agentData.profile}
          >
            {profiles.map((profile) => (
              <option key={profile.id} value={profile.id}>
                {profile.name}
              </option>
            ))}
          </Select>

          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Button variant="outlined" onClick={onClose} fullWidth>
                Cancel
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <Button
                variant="contained"
                type="submit"
                onClick={editAgentHandler}
                disabled={isLoading}
                fullWidth
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default UpdateAgentModal;
